<template>
    <div class="w-full flex flex-col items-center justify-between">
        <slot></slot>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>
